export const EmploySimpleName = 'Cortex Prime Solutions';
export const EmployName = 'Cortex Prime Solutions - Soluções em Sistemas';
export const Loading = 'Carregando';
export const LoadingDot = 'Carregando...';
export const AboutUs = 'Sobre nós';
export const WhyChooseUs = 'Por que nos escolher';